import type { NextPage } from 'next';
import { NextSeo } from 'next-seo';

import {
  DEFAULT_SEO_CONFIG,
  DEFAULT_SITE_DESCRIPTION,
  DEFAULT_SITE_TITLE,
} from '../../next-seo.config';
import { LegalHeader } from '../components/Header/LegalHeader';
import { CookieNotice } from '../components/Legal/CookieNotice';
import { PrivacyNotice } from '../components/Legal/PrivacyNotice';

const PrivacyPolicyPage: NextPage = () => {
  const PRIVACY_POLICY_DESCRIPTION = `Privacy Policy | ${DEFAULT_SITE_DESCRIPTION}`;
  const PRIVACY_POLICY_TITLE = `Privacy Policy | ${DEFAULT_SITE_TITLE}`;

  return (
    <>
      <NextSeo
        {...DEFAULT_SEO_CONFIG}
        title={PRIVACY_POLICY_TITLE}
        canonical="https://matcha.xyz/privacy"
        description={PRIVACY_POLICY_DESCRIPTION}
        openGraph={{ siteName: PRIVACY_POLICY_TITLE, description: PRIVACY_POLICY_DESCRIPTION }}
      />
      <LegalHeader />
      <PrivacyNotice />
      <CookieNotice />
    </>
  );
};

export default PrivacyPolicyPage;
